import { createSelector } from 'reselect';
import { map, isEmpty } from 'lodash';

export const getCourseRequests = createSelector(
  state => state.requests.data,
  data => map(Object.values(data), d => {
    const { requester, university, subject, number, title, _id } = d;
    return {
      _id,
      code: `${subject} ${number}`,
      title,
      requester: isEmpty(requester) ? 'Unknown User' : `${requester.first} ${requester.last}`,
      institution: university.name,
    };
  }),
);

export const getTutors = createSelector(
  state => state.tutors.main.data,
  tutors => map(Object.values(tutors), t => {
    const { _id, user, ratings, statistics, isAvailable, privateLocationsStatus } = t;
    const ratingsSum = ratings.reduce((acc, x) => acc + (x.total / x.count), 0);
    return {
      _id,
      name: isEmpty(user) ? 'Unknown User' : `${user.first} ${user.last}`,
      ratings: (ratingsSum / ratings.length).toFixed(2),
      mins: statistics.lessonHistory.minCount,
      completed: statistics.lessonHistory.count,
      available: isAvailable ? 'Yes' : '',
      privateLocationsStatus,
    };
  })
);



// WEBPACK FOOTER //
// ./src/modules/requests/selectors.js